
import LampCharge from "../../../assets/filled/LampCharge.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function LampChargeIcon({ className, dataTestid = "LampChargeIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <LampCharge data-testid={dataTestid} className={classes} {...rest} />
  );
}
